












import { Component, Mixins, Prop } from "vue-property-decorator";
import { MenuPane } from "../../../../panes";
import { ModelEditableMixin } from "../../../../system/mixins";
import { NumberSelector } from "../../../../system/selectors";
import { DocumentPageNavigatableMixin } from "../../mixins";

@Component({
  components: {
    MenuPane,
    NumberSelector,
  }
})
export default class PageNumberSelector extends Mixins(ModelEditableMixin, DocumentPageNavigatableMixin) {
  @Prop({ default: false })
  isHorizontal: boolean;

  get isDocumentAlreadyInitialized(): boolean {
    return this.isSourceEnable
      && this.editingSource.isAlreadyInitialized;
  }
}
